<div class="sp-mb-48">
  <div class="box sp-mt-24">
    <h4 class="sp-mb-24">Basic</h4>
    <ui-badge [uiCount]="5">
      <a class="head-example"></a>
    </ui-badge>
    <ui-badge [uiCount]="0" uiShowZero>
      <a class="head-example"></a>
    </ui-badge>
    <ui-badge [uiCount]="20">
      <ui-icon class="notification-icon" uiType="outline:notifications"></ui-icon>
    </ui-badge>
  </div>

  <div class="box sp-mt-24">
    <h4 class="sp-mb-24">Overflow count</h4>
    <ui-badge [uiCount]="99">
      <a class="head-example"></a>
    </ui-badge>
    <ui-badge [uiCount]="200">
      <a class="head-example"></a>
    </ui-badge>
    <ui-badge [uiCount]="200" [uiOverflowCount]="10">
      <a class="head-example"></a>
    </ui-badge>
    <ui-badge [uiCount]="10000" [uiOverflowCount]="999">
      <a class="head-example"></a>
    </ui-badge>
  </div>
  <div class="box sp-mt-24">
    <h4 class="sp-mb-24">Standalone</h4>
    <ui-badge uiStandalone [uiCount]="4" [uiStyle]="{ backgroundColor: '#fff', color: '#999', boxShadow: '0 0 0 1px #d9d9d9 inset' }"></ui-badge>
    <ui-badge uiStandalone [uiCount]="109" [uiStyle]="{ backgroundColor: '#52c41a' }"></ui-badge>
  </div>
  <div class="box sp-mt-24">
    <h4 class="sp-mb-24">Standalone with text</h4>
    <ui-badge uiColor="#2db7f5" uiText="#2db7f5"></ui-badge>
    <ui-badge uiColor="#87d068" uiText="#87d068"></ui-badge>
    <ui-badge uiColor="#108ee9" uiText="#108ee9"></ui-badge>
  </div>
  <div class="box sp-mt-24">
    <h4 class="sp-mb-24">Ribbon</h4>
    <ui-ribbon uiText="Pushes open the window">
      <ui-card>And raises the spyglass.</ui-card>
    </ui-ribbon>
  </div>
</div>
